import { Field } from 'formik'

const FormField = ({ children, name }) =>
  <Field name={name}>
    {props => children(props)}
  </Field>

export default FormField
